"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AuditsService", {
    enumerable: true,
    get: function() {
        return AuditsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphookslistenerservice = require("~/services/app-hooks-listener.service");
const _models = require("~/models");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _dataUtils = require("~/utils/dataUtils");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let AuditsService = class AuditsService {
    async recordAuditList(context, param) {
        const audits = await _models.Audit.recordAuditList(context, param);
        for (const audit of audits.list){
            try {
                const details = JSON.parse(audit.details || '{}');
                const { column_meta, data, old_data } = details;
                for (const col of Object.values(column_meta || {})){
                    // re-generate new signedUrl for attachment files
                    // to prevent it from expiring when displayed
                    if (col.type === _nocodbsdk.UITypes.Attachment) {
                        if (data && data[col.title]) {
                            await (0, _dataUtils.processConcurrently)(data[col.title], async (item)=>{
                                try {
                                    await _models.PresignedUrl.signAttachment({
                                        attachment: item,
                                        filename: item.title
                                    });
                                } catch (e) {}
                            }, 15);
                        }
                        if (old_data && old_data[col.title]) {
                            await (0, _dataUtils.processConcurrently)(old_data[col.title], async (item)=>{
                                try {
                                    await _models.PresignedUrl.signAttachment({
                                        attachment: item,
                                        filename: item.title
                                    });
                                } catch (e) {}
                            }, 15);
                        }
                    }
                }
                audit.details = JSON.stringify(details);
            } catch (e) {}
        }
        return audits;
    }
    constructor(appHooksListenerService, appHooksService){
        this.appHooksListenerService = appHooksListenerService;
        this.appHooksService = appHooksService;
    }
};
AuditsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphookslistenerservice.AppHooksListenerService === "undefined" ? Object : _apphookslistenerservice.AppHooksListenerService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], AuditsService);
